import React, { useState, useEffect } from 'react'
import NavbarWithSearch from './utils/NavbarWithSearch'
import { Container, Row, Col } from 'react-bootstrap'
import FormLC from './utils/FormLC'
import AlertModal from './utils/AlertModal'
import firebaseConfig from '../../../Utilities/Firebase'
import { useNavigate } from 'react-router'
import { getDatabase, ref, child, get } from 'firebase/database'
import { initializeApp } from 'firebase/app'
import { getAuth, onAuthStateChanged } from 'firebase/auth'

const GenerateLC = () => {
  const navigate = useNavigate()

  useEffect(() => {
    IsUserLogedIn()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  function IsUserLogedIn() {
    const FirebaseApp = initializeApp(firebaseConfig)
    const auth = getAuth(FirebaseApp)
    onAuthStateChanged(auth, user => {
      if (user === null) {
        navigate('/')
      }
    })
  }

  const [inputSAP, setInputSAP] = useState('')
  const [invalidSapError, setInvalidSapError] = useState(false)
  const [noDataError, setNoDataError] = useState(false)
  const [serverError, setServerError] = useState(false)
  const [loading, setLoading] = useState(false)
  const [retrievedSap, setRetrievedSap] = useState('')
  const [lName, setLName] = useState('')
  const [fName, setFName] = useState('')
  const [father, setFather] = useState('')
  const [mother, setMother] = useState('')
  const [religion, setReligion] = useState('')
  const [subcaste, setSubcaste] = useState('')
  const [nationality, setNationality] = useState('')
  const [POB, setPOB] = useState('') //Place of birth
  const [DOB, setDOB] = useState('')
  const [prevCollege, setPrevCollege] = useState('')
  const [lcAlreadyGenerated, setLcAlreadyGenerated] = useState(false)
  const progress = 'Good'
  const conduct = 'Good'
  const [LCNumber, setLCNumber] = useState(0)
  const [dateAdmission, setDateAdmission] = useState('')
  const [degree, setDegree] = useState('')
  const [course, setCourse] = useState('')
  const [dateLeaving, setDateLeaving] = useState('')
  const [cgpa, setCgpa] = useState('')
  const [emptyFields, setEmptyFields] = useState(false)
  function submitSAP() {
    setRetrievedSap('')
    setLName('')
    setFName('')
    setFather('')
    setMother('')
    setReligion('')
    setSubcaste('')
    setNationality('')
    setPOB('')
    setDOB('')
    setPrevCollege('')
    setDateAdmission('')
    setDegree('')
    setCourse('')
    setDateLeaving('')
    setCgpa('')
    if (inputSAP.length === 0) {
      setInvalidSapError(true)
    } else {
      setLoading(true)
      const FirebaseApp = initializeApp(firebaseConfig)
      const db = ref(getDatabase(FirebaseApp))
      get(child(db, `student_data/${inputSAP}`))
        .then(snapshot => {
          if (snapshot.exists()) {
            const data = snapshot.val()
            console.log(data.course)
            setCourse(data.course)
            setDOB(data.dob)
            setFather(data.father_name)
            setMother(data.mother_name)
            setFName(data.first_name)
            setLName(data.last_name)
            setDateAdmission(data.registration_date)
            console.log(data.registration_date)
            setReligion(data.religion)
            setRetrievedSap(data.sap_id)
            setSubcaste(data.sub_caste)
            setNationality('Indian')
            if (data.cgpa) {
              setCgpa(`Passed - ${data.course} - with cgpa ${data.cgpa} `)
            } else {
              setCgpa(`Passed - ${data.course} - with cgpa`)
            }
            setLoading(false)
          } else {
            setNoDataError(true)
            setLoading(false)
          }
        })
        .catch(error => {
          console.log(error)
          setServerError(true)
          setLoading(false)
        })
      get(child(db, `number_of_lc`))
        .then(snapshot => {
          if (snapshot.exists()) {
            let number = snapshot.val()
            setLCNumber(number)
          } else {
            console.log('Nothing')
          }
        })
        .catch(error => {
          console.log(error)
        })
    }
  }
  return (
    <div style={{ fontSize: 'large' }}>
      <AlertModal
        show={invalidSapError}
        setFunction={setInvalidSapError}
        header={`Invalid SAP ID`}
        body={`SAP ID should be 11 digits long`}
      />
      <AlertModal
        show={noDataError}
        setFunction={setNoDataError}
        header={`No Data`}
        body={`No Data for Entered SAP ID`}
      />
      <AlertModal
        show={serverError}
        setFunction={setServerError}
        header={`Some Server side error`}
        body={`Something went wrong!`}
      />
      <AlertModal
        show={lcAlreadyGenerated}
        setFunction={setLcAlreadyGenerated}
        header={`LC for entered SAP ID already generated`}
        body={`Please check`}
      />
      <AlertModal
        show={emptyFields}
        setFunction={setEmptyFields}
        header={`Some fields are empty`}
        body={`Please check`}
      />
      <NavbarWithSearch loading={loading} setInputSAP={setInputSAP} submitSAP={submitSAP} />
      <Container>
        <Row style={{ marginTop: '1rem' }}>
          <Col md={{ span: 6, offset: 3 }} style={{ textAlign: 'center' }}>
            <h2>LC Review</h2>
            <h5>Below are the details of the student</h5>
          </Col>
        </Row>
        <FormLC
          retrievedSap={retrievedSap}
          setRetrievedSap={setRetrievedSap}
          lName={lName}
          setLName={setLName}
          fName={fName}
          setFName={setFName}
          father={father}
          setFather={setFather}
          mother={mother}
          setMother={setMother}
          religion={religion}
          setReligion={setReligion}
          subcaste={subcaste}
          setSubcaste={setSubcaste}
          nationality={nationality}
          setNationality={setNationality}
          POB={POB}
          setPOB={setPOB}
          DOB={DOB}
          setDOB={setDOB}
          prevCollege={prevCollege}
          setPrevCollege={setPrevCollege}
          progress={progress}
          conduct={conduct}
          dateAdmission={dateAdmission}
          setDateAdmission={setDateAdmission}
          degree={degree}
          setDegree={setDegree}
          course={course}
          setCourse={setCourse}
          dateLeaving={dateLeaving}
          setDateLeaving={setDateLeaving}
          setLcAlreadyGenerated={setLcAlreadyGenerated}
          setServerError={setServerError}
          setEmptyFields={setEmptyFields}
          lcAlreadyGenerated={lcAlreadyGenerated}
          LCNumber={LCNumber}
          setCgpa={setCgpa}
          cgpa={cgpa}
        />
      </Container>
    </div>
  )
}

export default GenerateLC
